import PropTypes from 'prop-types';

import notifications from 'notifications';
import * as net from 'util/Net';

// Keep in sync with esignature.py
export const SIGNATURE_TYPE_AZURE_AD = 'AZURE_AD';
export const SIGNATURE_TYPE_OKTA = 'OKTA';
export const SIGNATURE_TYPE_SAML = 'SAML';

export const ESIGNATURE_CONFIG_SHAPE = PropTypes.shape({
  type: PropTypes.oneOf([SIGNATURE_TYPE_AZURE_AD, SIGNATURE_TYPE_OKTA, SIGNATURE_TYPE_SAML]).isRequired,
  oktaHost: PropTypes.string,
}).isRequired;

export default function createEsignature(username, password, esignatureConfig) {
  switch (esignatureConfig.type) {
    case SIGNATURE_TYPE_OKTA:
      return Promise.resolve(
        net.postJSON({
          url: `${esignatureConfig.oktaHost}/api/v1/authn`,
          data: {
            username,
            password,
            options: {
              multiOptionalFactorEnroll: false,
              warnBeforePasswordExpired: false,
            },
          },
        })
      )
        .catch(() => {
          throw new Error(`Error connecting to ${esignatureConfig.oktaHost}`);
        })
        .then(({status, sessionToken}) => {
          if (status === 'MFA_REQUIRED') {
            notifications.error('Validation requires MFA and is not currently supported');
            throw new Error('Error due to MFA not supported');
          }
          if (status !== 'SUCCESS') {
            throw new Error(`Auth had success status code but status in response was ${status}`);
          }
          return {
            signature: sessionToken,
            signatureType: SIGNATURE_TYPE_OKTA,
          };
        });
    default:
      throw new Error(`Unexpected esignature type: ${esignatureConfig.type}`);
  }
}
